import SxSReadingPaneStrategy, {
    SxSConversationReadingPaneStrategy,
    SxSItemReadingPaneStrategy,
} from '../types/SxSReadingPaneStrategy';
import { ClientItemId } from 'owa-client-ids';
import { InstrumentationContext } from 'owa-mail-store';
import { PreviewPaneSelectionSource } from 'owa-sxs-store';
import { action } from 'satcheljs';

export const initializeReadingPaneInSxS = action(
    'initializeReadingPaneInSxS',
    (
        readingPaneStrategy: SxSReadingPaneStrategy,
        previewPaneSelectionSource: PreviewPaneSelectionSource,
        parentItemId: ClientItemId,
        instrumentationContext: InstrumentationContext,
        sxsId: string,
        isProjectionPopout: boolean
    ) => ({
        readingPaneStrategy,
        previewPaneSelectionSource,
        parentItemId,
        instrumentationContext,
        sxsId,
        isProjectionPopout,
    })
);

export const initializeConversationReadingPaneInSxS = action(
    'initializeConversationReadingPaneInSxS',
    (
        readingPaneStrategy: SxSConversationReadingPaneStrategy,
        previewPaneSelectionSource: PreviewPaneSelectionSource,
        parentItemId: ClientItemId,
        instrumentationContext: InstrumentationContext,
        sxsId: string
    ) => ({
        readingPaneStrategy,
        previewPaneSelectionSource,
        parentItemId,
        instrumentationContext,
        sxsId,
    })
);

export const initializeItemReadingPaneInSxS = action(
    'initializeItemReadingPaneInSxS',
    (
        readingPaneStrategy: SxSItemReadingPaneStrategy,
        instrumentationContext: InstrumentationContext,
        sxsId: string
    ) => ({
        readingPaneStrategy,
        instrumentationContext,
        sxsId,
    })
);

export const initializeReadingPaneInSxSByCopyingMailReadingPane = action(
    'initializeReadingPaneInSxSByCopyingMailReadingPane',
    (
        previewPaneSelectionSource: PreviewPaneSelectionSource,
        parentItemId: ClientItemId,
        instrumentationContext: InstrumentationContext,
        sxsId: string,
        isProjectionPopout: boolean
    ) => ({
        previewPaneSelectionSource,
        parentItemId,
        instrumentationContext,
        sxsId,
        isProjectionPopout,
    })
);
